import * as React from 'react';
import { useState } from 'react';
import { getEngineChatContent } from '../../tools/apiTools';
import { RequirementsProps } from '../../tools/context';
import IframeContent from '../IframeContent';

export interface EnginePageV2Props {
  requirements: RequirementsProps;
  componentStates: {
    content: string;
  };
  navigation: any;
  headerButtons: any;
}

const Renderer: React.FC<EnginePageV2Props> = ({ componentStates }) => {
  const [iframeHeight, setIframeHeight] = useState(1200);
  const { content } = componentStates || {};

  if (!content) return null;

  return (
    <div className="EnginePage" style={{ height: iframeHeight }}>
      <IframeContent html={content} updateIframeHeight={setIframeHeight} />
    </div>
  );
};

const preloader = async (data: { chatId: string }, requirements: RequirementsProps) => {
  const content = await getEngineChatContent(data.chatId);

  return {
    requirements,
    content,
  };
};

const EnginePageV2 = { Renderer, preloader };

export default EnginePageV2;
export { Renderer, preloader };
